import { BaseService } from "@/services/BaseService";
import type { Reservation } from "@/types/reservation";

export interface SendPreCheckoutReminderResponse {
  bookingId: string;
  preCheckoutUrl: string;
  channelId: string;
  messageId?: string;
  preCheckoutStatus: Reservation["preCheckoutStatus"];
  message: string;
}

class BookingCheckoutService extends BaseService {
  private basePath = "/booking-checkouts";

  sendPreCheckoutReminder(
    bookingId: string,
  ): Promise<SendPreCheckoutReminderResponse> {
    return this.request<SendPreCheckoutReminderResponse>(
      `${this.basePath}/bookings/${bookingId}/reminder`,
      {
        method: "POST",
        disableToast: true,
      },
    );
  }
}

export const bookingCheckoutService = new BookingCheckoutService();
